import { StaticImage } from "gatsby-plugin-image"

export default [
  {
    title: "Personalisierte Formel",
    description: "Creme oder Gel mit aktiven Wirkstoffen für Deine Haut",
    image: ({ className }) => (
      <StaticImage
        src="../../../images/rebranded/two-month-package/2m-package-slider_slide3.png"
        alt=""
        height={56}
        className={className}
      />
    ),
    details: {
      title: "Deine Formel",
      slides: [
        ({ className }) => (
          <StaticImage
            src="../../../images/rebranded/rebranded-formula-01.png"
            alt=""
            objectFit="contain"
            objectPosition="center center"
            className={className}
          />
        ),
        ({ className }) => (
          <StaticImage
            src="../../../images/rebranded/rebranded-formula-ingredient.png"
            alt=""
            objectFit="cover"
            objectPosition="center center"
            className={className}
          />
        ),
      ],
      primaryColor: "primary",
      secondaryColor: "lightGreen",
      callout: {
        title: "Auf Dich zugeschnitten",
        description:
          "<p>Deine finale Diagnose und die Inhaltsstoffe Deiner Formel erhältst Du nachdem Deine Ärztin Deine Hautanalyse und Bilder gesehen hat.</p> <p>Wenn sich Deine Haut während der Behandlung ändert, passt Deine Ärztin die Zusammensetzung der Wirkstoffe von Lieferung zu Lieferung an.</p>",
        textColor: "background",
      },
      sections: [
        {
          title: "Unsere Superstar-Wirkstoffe",
          description:
            "Deine Formel kann einige dieser Inhaltsstoffe beinhalten. Über die finale Zusammensetzung wird im Anschluss Deine Ärztin entscheiden.",
        },
      ],
      ingredients: [
        {
          title: "Tretinoin",
          image: ({ className }) => (
            <StaticImage
              src="../../../images/plan-selection/tretinoin.png"
              alt=""
              className={className}
            />
          ),
          lines: [
            "Beschleunigt die Zellerneuerung",
            "Wirkt komedolytisch (Mitesser auflösend)",
          ],
        },
        {
          title: "Niacinamide",
          image: ({ className }) => (
            <StaticImage
              src="../../../images/plan-selection/niacinamide.png"
              alt=""
              className={className}
            />
          ),
          lines: [
            "Ist eine Form des Vitamin B",
            "Stärkt die Hautbarriere",
            "Verfeinert das Hautbild",
          ],
        },
        {
          title: "Benzoylperoxid",
          image: ({ className }) => (
            <StaticImage
              src="../../../images/plan-selection/benzoylperoxid.png"
              alt=""
              className={className}
            />
          ),
          lines: [
            "Wirkt antibakteriell",
            "Wirkt komedolytisch (Mitesser auflösend)",
          ],
        },
        {
          title: "Azelainsäure",
          image: ({ className }) => (
            <StaticImage
              src="../../../images/plan-selection/azelainsaure.png"
              alt=""
              className={className}
            />
          ),
          lines: [
            "Wirkt entzündungshemmend",
            "Reduziert Pigmentflecken und Pickelmale",
          ],
        },
        {
          title: "Clindamycin",
          image: ({ className }) => (
            <StaticImage
              src="../../../images/plan-selection/clindamycin.png"
              alt=""
              className={className}
            />
          ),
          lines: [
            "Ist ein topisches Antibiotikum",
            "Hemmt Akne auslösenden Bakterien",
          ],
        },
        {
          title: "Erythromycin",
          image: ({ className }) => (
            <StaticImage
              src="../../../images/plan-selection/erythromycin.png"
              alt=""
              className={className}
            />
          ),
          lines: [
            "Wirkt anti-bakteriell und anti-entzündlich",
            "Wird unter anderem eingesetzt bei perioraler Dermatitis ",
          ],
        },
      ],
    },
  },
  {
    title: "Die Reinigung",
    description: "Befreit Deine Haut sanft von Talg, Schmutz und Make-up",
    image: ({ className }) => (
      <StaticImage
        src="../../../images/rebranded/two-month-package/2m-package-slider_slide5.png"
        alt=""
        height={56}
        className={className}
      />
    ),
    details: {
      title: "Deine Reinigung",
      slides: [
        ({ className }) => (
          <StaticImage
            src="../../../images/rebranded/rebranded-cleanser-01.png"
            alt=""
            objectFit="contain"
            objectPosition="center center"
            className={className}
          />
        ),
        ({ className }) => (
          <StaticImage
            src="../../../images/rebranded/rebranded-cleanser-ingredient.png"
            alt=""
            objectFit="cover"
            objectPosition="center center"
            className={className}
          />
        ),
      ],
      primaryColor: "blue",
      secondaryColor: "lightBlue",
      callout: {
        title: "Passend zu Deiner Haut",
        description:
          "Deine Ärztin wird Dir - je nach Hauttyp und Behandlung - eine unserer beiden Reinigungen auswählen. Dies kannst Du von Set zu Set anpassen.",
        textColor: "text",
      },
      sections: [
        {
          title: "Das Reinigungsgel",
          description:
            "<p>Das Reinigungsgel befreit Deine Haut sanft von überschüssigem Talg, Schmutz und Make-up. Das milde Gel beinhaltet einen Komplex aus Salicylsäure mit einem langsameren Penetrations-System.</p> <p>Die Salicylsäure ermöglicht es Deiner Haut, die Wirkstoffe der Pflege und Deiner Formel besser aufzunehmen. Währendessen mildert das langsamere Penetrations-System die Nebenwirkungen der Salicylsäure.</p>",
        },
        {
          title: "Das Reinigungsöl",
          description:
            "<p>Das Reinigungsöl reinigt die Haut effektiv, ohne sie auszutrocknen. Es entfernt sogar Lippen- und Augen-Make-up und wasserfeste Produkte, ohne ölige Rückstände zu hinterlassen.</p> <p>Zudem enthält es Antioxidantien und ist für alle Hauttypen geeignet.</p>",
        },
      ],
    },
  },
  {
    title: "Die Pflege",
    description: "Beruhigt Deine Haut und spendet nötige Feuchtigkeit",
    image: ({ className }) => (
      <StaticImage
        src="../../../images/rebranded/two-month-package/2m-package-slider_slide4.png"
        alt=""
        height={56}
        className={className}
      />
    ),
    details: {
      title: "Deine Pflege",
      slides: [
        ({ className }) => (
          <StaticImage
            src="../../../images/rebranded/rebranded-moisturizer-01.png"
            alt=""
            objectFit="contain"
            objectPosition="center center"
            className={className}
          />
        ),
        ({ className }) => (
          <StaticImage
            src="../../../images/rebranded/rebranded-moisturizer-02.png"
            alt=""
            objectFit="contain"
            objectPosition="center center"
            className={className}
          />
        ),
        ({ className }) => (
          <StaticImage
            src="../../../images/rebranded/rebranded-moisturizer-ingredient.png"
            alt=""
            objectFit="cover"
            objectPosition="center center"
            className={className}
          />
        ),
      ],
      primaryColor: "darkRose",
      secondaryColor: "hsla(344, 69%, 97%, 1)",
      callout: {
        title: "Passend zu Deiner Haut",
        description:
          "Deine Ärztin wird Dir je nach Hauttyp und Behandlung eine unserer beiden Pflegen auswählen. Dies kannst Du von Set zu Set anpassen.",
        textColor: "text",
      },
      sections: [
        {
          title: "Die leichte Pflege",
          description:
            "Du wünschst Dir eine zarte Feuchtigkeitscreme, die die Haut hydratisiert und ein geschmeidiges Hautgefühl hinterlässt? Unsere leichte Pflege wurde speziell für ölige und zu Akne neigende Hauttypen entwickelt – aber auch normale Hauttypen und Mischhaut freuen sich über diese leichte Pflegecreme.",
        },
        {
          title: "Die reichhaltige Pflege",
          description:
            "<p>Du wünscht Dir eine Pflege mit langanhaltender hydratisierender Wirkung? Die reichhaltige Pflege wurde speziell für trockene Haut entwickelt, aber auch alle anderen Hauttypen können von ihr profitieren:</p> <p>Denn sie kann den Begleiterscheinungen mancher Wirkstoffe (z.B. Trockenheit, Rötungen und Reizungen) entgegenwirken und vorbeugen.</p>",
        },
      ],
    },
  },
]
